import React from 'react'
import Project from '../components/Project'

function ProjectPage() {
  return (
    <>
       <div className="main">
      <p>My Project</p>
      </div>
      <Project />
    </>
  )
}

export default ProjectPage
